import { CheckboxProps } from './props';
import styles from './styles.module.scss';

/**
 * A customizable checkbox component that can be checked/unchecked and show loading state
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.isChecked - Whether the checkbox is checked
 * @param {() => void} props.onClick - Click handler function
 * @param {boolean} props.isLoading - Whether to show loading skeleton state
 * @param {boolean} props.isLarge - Whether to use large size variant
 * @param {boolean} props.disabled - Whether the checkbox is disabled
 * @returns {JSX.Element} Checkbox component or loading skeleton
 */
export function Checkbox({
  isChecked,
  onClick,
  isLoading,
  isLarge,
  disabled,
}: CheckboxProps) {
  // Show loading skeleton if isLoading is true
  if (isLoading) {
    return (
      <div
        className={`${styles.skeleton} ${isLarge ? styles['skeleton--large'] : ''}`}
      />
    );
  }

  // Render checkbox with conditional styling based on state
  return (
    <div
      className={`${styles.checkbox} ${isChecked ? styles['checkbox--checked'] : ''} ${isLarge ? styles['checkbox--large'] : ''} ${disabled ? styles['checkbox--disabled'] : ''}`}
      onClick={onClick}
    >
      <i className="fa-solid fa-check" />
    </div>
  );
}
